let baseUrl = document.getElementsByTagName('base')[0].getAttribute('href');
const isProduction = process.env.NODE_ENV === 'production';

if (!isProduction) {
  baseUrl = process.env.BASE_URL;
}

let apiBaseUrl = baseUrl.replace(/\/web$/g, '');

if (!isProduction) {
  apiBaseUrl = process.env.VUE_APP_API_BASE_URL;
}

export default {
  baseUrl,
  apiBaseUrl,
};
